import React from "react";
import { Col } from "react-bootstrap";
import { UrlFixer } from "../../utils/utils";
import { ListItemThumb } from "../../utils/common-styles";
import {
  ListItemDate,
  ListItemText,
  ListItemLink,
  EventListItemContainerRow,
} from "../../utils/common-styles";
import Markdown from "react-markdown";
import { useNavigate } from "react-router-dom";


export const EventListItem = ({ event }) => {
  const navigate = useNavigate();

  const clickHandler = (id, slug) => {
    let targetUrl = `/events/${id}/${slug}`;
    navigate(targetUrl);
  };

  return (
    <>
      <EventListItemContainerRow
        onClick={(e) => clickHandler(event.id, event.slug)}
      >
        <Col xs={12} md={3}>
          <ListItemThumb>
            {event.image_attrs && (
              <img src={UrlFixer(event.image_attrs.url)} alt={event.title} />
            )}
          </ListItemThumb>
        </Col>
        <ListItemDate xs={12} md={3} className="event-date">
          <h4>
            {new Date(event.starts_at).toLocaleString("default", {
              month: "long",
            })}
          </h4>
          <span className="daynum">
            <h1>{new Date(event.starts_at).getDate()}</h1>
          </span>
        </ListItemDate>
        <ListItemText xs={12} md={6} className="event-meta">
          <h4><a href={`/events/${event.id}/${event.slug}`}>{event.title}</a></h4>
          <span>
            <Markdown>{event.intro}</Markdown>
          </span>
          <ListItemLink to={`/events/${event.id}/${event.slug}`}>
            Read more
          </ListItemLink>
        </ListItemText>
      </EventListItemContainerRow>
    </>
  );
};
